import { render, staticRenderFns } from "./wDetails2.0.vue?vue&type=template&id=f2e8f2ce&scoped=true&"
import script from "./wDetails2.0.vue?vue&type=script&lang=js&"
export * from "./wDetails2.0.vue?vue&type=script&lang=js&"
import style0 from "./wDetails2.0.vue?vue&type=style&index=0&id=f2e8f2ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e8f2ce",
  null
  
)

export default component.exports